export type Language = "en" | "pl";

export interface EventPageTranslations {
  backButtonText: string;
  loadingText: string;
  infoButtonText: string;
  introTitle: string;
  closeIntroButton: string;
}

export interface EventInfoTranslations {
  howToOrderTitle: string;
  howToOrderText: string;
  facebookText: string;
  instagramText: string;
  priceListTitle: string;
  priceListOption1: string;
  priceListOption2: string;
  priceListAdditional: string;
  priceListSingle: string;
  specialNoteEdited: string;
  specialNoteAccess: string;
}

export interface OrderPageTranslations {
  loadingText: string;
  downloadButtonText: string;
  introTitle: string;
  introParagraph1: string;
  availableUntilText: string;
  pleaseDownloadText: string;
  introDownloadIndividualPhotosInstruction: string;
  introDownloadZipInstruction: string;
  closeIntroButton: string;
}

export interface ImageLoaderTranslations {
  loadingText: string;
  loadingFullQualityText: string;
}

export const eventPageTranslations: Record<Language, EventPageTranslations> = {
  en: {
    backButtonText: "Back",
    loadingText: "Loading event data...",
    infoButtonText: "Info & price",
    introTitle: "Event Photos",
    closeIntroButton: "Hide",
  },
  pl: {
    backButtonText: "Wróć",
    loadingText: "Wczytywanie danych wydarzenia...",
    infoButtonText: "Informacje i cennik",
    introTitle: "Zdjęcia z wydarzenia",
    closeIntroButton: "Schowaj",
  },
};

export const orderPageTranslations: Record<Language, OrderPageTranslations> = {
  en: {
    loadingText: "Loading order data...",
    downloadButtonText: "Download All Photos",
    introTitle: "Your Photos",
    introParagraph1: "Below are the edited photos, ready for download.",
    availableUntilText: `The gallery will be available until`,
    pleaseDownloadText: `Please download your photos by this date.`,
    introDownloadIndividualPhotosInstruction:
      "Individual photos can be downloaded by clicking the arrow in the corner of each thumbnail.",
    introDownloadZipInstruction:
      "All photos can be also downloaded as a ZIP file using the button above.",
    closeIntroButton: "Hide",
  },
  pl: {
    loadingText: "Wczytywanie danych zamówienia...",
    downloadButtonText: "Pobierz wszystkie zdjęcia",
    introTitle: "Twoje zdjęcia",
    introParagraph1:
      "Poniżej znajdują się zedytowane zdjęcia, gotowe do pobrania.",
    availableUntilText: "Galeria będzie dostępna do",
    pleaseDownloadText: "Do tego dnia należy pobrać zdjęcia.",
    introDownloadIndividualPhotosInstruction:
      "Zdjęcia można pobrać klikając na strzałkę w rogu kafelka.",
    introDownloadZipInstruction:
      "Można też użyć przycisku powyżej, żeby pobrać wszystkie zdjęcia jako plik ZIP.",
    closeIntroButton: "Ukryj",
  },
};

export const galleryTranslations: Record<Language, { loadingText: string }> = {
  en: {
    loadingText: "Loading photos...",
  },
  pl: {
    loadingText: "Wczytywanie zdjęć...",
  },
};

export const imageViewerTranslations: Record<
  Language,
  { downloadButtonText: string }
> = {
  en: {
    downloadButtonText: "Download Image",
  },
  pl: {
    downloadButtonText: "Pobierz zdjęcie",
  },
};

export const eventInfoTranslations: Record<Language, EventInfoTranslations> = {
  en: {
    howToOrderTitle: "How to order photos:",
    howToOrderText:
      "If you would like to purchase any pictures, please contact me via Facebook or Instagram:",
    facebookText: "Marta Wlazło Photography",
    instagramText: "marta.wlazlo.photography",
    priceListTitle: "Price list:",
    priceListOption1: "4 photos",
    priceListOption2: "Each additional photo",
    priceListAdditional: "150 zł / 35 €",
    priceListSingle: "Single photo (if less than 4)",
    specialNoteEdited: "All pictures from the gallery will be edited ✨",
    specialNoteAccess:
      "You will receive access to the final edited photos in electronic form.",
  },
  pl: {
    howToOrderTitle: "Jak zamówić zdjęcia:",
    howToOrderText:
      "Jeśli chcesz kupić jakiekolwiek zdjęcia, skontaktuj się ze mną przez Facebook lub Instagram:",
    facebookText: "Marta Wlazło Photography",
    instagramText: "marta.wlazlo.photography",
    priceListTitle: "Cennik:",
    priceListOption1: "4 zdjęcia",
    priceListOption2: "Każde dodatkowe zdjęcie",
    priceListAdditional: "150 zł / 35 €",
    priceListSingle: "Pojedyncze zdjęcie (jeśli mniej niż 4)",
    specialNoteEdited: "Wszystkie zdjęcia z galerii będą poddane edycji ✨",
    specialNoteAccess:
      "Otrzymasz dostęp do finalnych, edytowanych zdjęć w formie elektronicznej.",
  },
};

export const imageLoaderTranslations: Record<
  Language,
  ImageLoaderTranslations
> = {
  en: {
    loadingText: "Loading...",
    loadingFullQualityText: "Loading full quality...",
  },
  pl: {
    loadingText: "Wczytywanie...",
    loadingFullQualityText: "Wczytywanie pełnej jakości...",
  },
};
